/* Fiche produit : la vidéo se lance seule, la galerie défile toute seule. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const STILL = 4500;   /* durée d'une photo, en ms */
  const MAX_VIDEO = 20000; /* une vidéo qui ne se termine pas passe à la suite après ce délai */

  function init() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.dataset.akInit) return;
    gallery.dataset.akInit = '1';

    const thumbs = () => [...gallery.querySelectorAll('.thumbnail-list__item .thumbnail, .thumbnail-list .thumbnail')];
    const activeSlide = () => gallery.querySelector('.product__media-item.is-active');
    let timer, paused = false, visible = true;
    /* on ne change d'image que si la galerie est visible à l'écran */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(es => { visible = es[0].isIntersecting; }, { threshold: 0.2 }).observe(gallery);
    }

    const next = () => {
      const t = thumbs();
      if (t.length < 2) return;
      let i = t.findIndex(x => x.getAttribute('aria-current') === 'true');
      i = (i + 1) % t.length;
      /* le thème fait remonter la page vers la galerie quand l'image change : on l'empêche */
      const keep = window.scrollTo;
      window.scrollTo = () => {};
      t[i].click();
      setTimeout(() => { window.scrollTo = keep; }, 50);
    };

    const schedule = ms => { clearTimeout(timer); timer = setTimeout(step, ms); };

    const handle = () => {
      const slide = activeSlide();
      const dm = slide && slide.querySelector('deferred-media');
      if (dm && dm.querySelector('template')) {
        if (!dm.getAttribute('loaded')) { try { dm.loadContent(false); } catch (e) {} }
        const v = dm.querySelector('video');
        if (v) {
          v.muted = true; v.loop = false; v.setAttribute('playsinline', '');
          v.play().catch(() => {});
          const done = () => { v.removeEventListener('ended', done); schedule(400); };
          v.addEventListener('ended', done);
          schedule(MAX_VIDEO);
          return;
        }
      }
      if (!reduce) schedule(STILL);
    };

    const step = () => {
      if (paused || document.hidden || !visible) { schedule(1000); return; }
      next();
      setTimeout(handle, 900);
    };

    /* On met en pause quand le visiteur survole ou touche la galerie */
    gallery.addEventListener('pointerenter', () => { paused = true; });
    gallery.addEventListener('pointerleave', () => { paused = false; });
    gallery.addEventListener('click', e => { if (e.target.closest('.thumbnail, .slider-button')) { setTimeout(handle, 900); } });

    setTimeout(handle, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
